import { FC } from "react";
import { Box } from "@mui/material";
import { headerHeight } from "../../NavBars/Header/hardCodeData";
import { carModelsExplore } from "./hardCodeData";
import { useSearchParams } from "react-router-dom";
import FirstContent from "./Components/FirstContent";

const Explore: FC = () => {
  const [searchParams] = useSearchParams();
  const carId = searchParams.get("carId");
  const carModel = carModelsExplore.find((car) => car.id === +carId!);

  return (
    <Box
      sx={{
        minHeight: `calc(100vh - ${headerHeight})`,
      }}
    >
      <FirstContent 
        firstContent={carModel?.firstContent}
        pdfFileName={carModel?.pdfFileName}
        carId={carModel?.id}
      />
    </Box>
  );
};

export default Explore;
